import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import "./i18n";
import App from "./App";
import { AuthProvider } from "./auth/AuthContext";
import { AdminGate } from "./auth/AdminGate";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <AdminGate>
          <App />
        </AdminGate>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>,
);

reportWebVitals();
